/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 13:30:06
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-06 16:56:00
 */
import React, { useEffect } from 'react' ;

const OfficeNotice = (props) => {
  useEffect(() =>{
    let x = props.data ;
    // console.log("indexoffice",props);
  },[props]);
  
  return(
    <div className="office-notice-block">
      <p>
        中华人民共和国人力资源和社会保障部官方公告
      </p>
      <p>
        <a 
          href={props.data[0].url.match(/(http|https):\/\/([\w.]+\/?)\S*/) ? `${props.data[0].url}`
                : `${props.proto}//${props.data[0].url}`} 
          target="_blank">
          {props.data[0].title}
        </a>
      </p>
      <p>
        <a
          href={props.data[1].url.match(/(http|https):\/\/([\w.]+\/?)\S*/) ? `${props.data[1].url}`
                : `${props.proto}//${props.data[1].url}`} 
          target="_blank"
          >
          {props.data[1].title}
        </a>
      </p>
    </div>
  )
}

export default OfficeNotice ;